@if (savedSearches?.length && !iconWithButton) {
  <button mat-icon-button #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="savedSearchMenu" (click)="$event.stopPropagation()">
    @if (caretDirection === 'right') {
      <mat-icon>chevron_right</mat-icon>
    }
    @if (caretDirection === 'down') {
      <mat-icon>arrow_drop_down</mat-icon>
    }
  </button>
}
@if (savedSearches?.length && iconWithButton) {
  <div #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="savedSearchMenu" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
    @if (caretDirection === 'right') {
      <mat-icon>chevron_right</mat-icon>
    }
    @if (caretDirection === 'down') {
      <mat-icon>arrow_drop_down</mat-icon>
    }
  </div>
}

<mat-menu class="saved-search-menu" #savedSearchMenu="matMenu" [overlapTrigger]="false">
  <h4 class="menu-item-title">
    <span>{{ 'watson.saved.search.title' | translate }}</span>
    <mat-icon>bookmark_add</mat-icon>
  </h4>

  @for (ss of savedSearches; track ss) {
    <section>
      @if (!ss.hidden) {
        <a
          class="menu-item-button on-hover dont-flex-on-me"
          mat-menu-item
          [routerLink]="'/warehouses/' + division._id + '/issues'"
          [queryParams]="{ search: ss._id }"
          [class.active]="ss._id === savedSearch?._id"
          >
          <div class="menu-item-wrapper">
            <span>{{ ss.name }}</span>
            <button mat-icon-button class="inner-button" [matMenuTriggerFor]="savedSearchExtraMenu" [matMenuTriggerData]="{ ss }" appPreventDefault>
              <mat-icon>more_vert</mat-icon>
            </button>
          </div>
        </a>
      }
    </section>
  }
</mat-menu>

<mat-menu #savedSearchExtraMenu="matMenu" [overlapTrigger]="false">
  <ng-template matMenuContent let-ss="ss">
    <app-save-search-action data-role="edit" [savedSearch]="ss" [editMode]="true"></app-save-search-action>
    <button data-role="delete" mat-menu-item (click)="delete(ss)">
      <mat-icon>delete</mat-icon>
      <span>{{ 'commons.btn.delete' | translate }}</span>
    </button>
  </ng-template>
</mat-menu>
